import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import SsoLogoutPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createSsoLogoutScreen = ({ loginLink }) => {
  const root = createRoot(document.getElementById('ssoLogoutPanel'));
  if (isSupportedBrowser()) {
    root.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <SsoLogoutPanel loginLink={loginLink} />
        </AuthScreenLayout>
      </Provider>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createSsoLogoutScreen = createSsoLogoutScreen;
